import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

document.addEventListener('DOMContentLoaded', () => {

    const gallerySelector = '[data-gallery="apartment-gallery"]';

    const elements = document.querySelectorAll(`${gallerySelector} a`);

    elements.forEach(el => {
        el.removeAttribute('title');
    });

    GLightbox({
        selector: gallerySelector,
        touchNavigation: true,
        loop: true,
        zoomable: true
    });

});